import React, { useState } from 'react';
import NavigationBar from '../../components/navigation/NavigationBar';
import { NotificationProvider, useNotification } from '../../components/ui/NotificationToast';
import ProfileSection from './components/ProfileSection';
import SecuritySection from './components/SecuritySection';
import PreferencesSection from './components/PreferencesSection';
import IntegrationsSection from './components/IntegrationsSection';
import SubscriptionSection from './components/SubscriptionSection';
import Icon from '../../components/AppIcon';

const UserProfileSettingsContent = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const { showSuccess, showError, showWarning } = useNotification();

  const tabs = [
    { id: 'profile', label: 'Profile', icon: 'User' },
    { id: 'security', label: 'Security', icon: 'Shield' },
    { id: 'preferences', label: 'Preferences', icon: 'Settings' },
    { id: 'integrations', label: 'Integrations', icon: 'Link' },
    { id: 'subscription', label: 'Subscription', icon: 'CreditCard' }
  ];

  const handleUpdate = (data) => {
    console.log('Updated data:', data);
  };

  const handleShowNotification = (type, title, message) => {
    if (type === 'success') {
      showSuccess(title, message);
    } else if (type === 'error') {
      showError(title, message);
    } else if (type === 'warning') {
      showWarning(title, message);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileSection onUpdate={handleUpdate} onShowNotification={handleShowNotification} />;
      case 'security':
        return <SecuritySection onShowNotification={handleShowNotification} />;
      case 'preferences':
        return <PreferencesSection onShowNotification={handleShowNotification} />;
      case 'integrations':
        return <IntegrationsSection onShowNotification={handleShowNotification} />;
      case 'subscription':
        return <SubscriptionSection onShowNotification={handleShowNotification} />;
      default:
        return <ProfileSection onUpdate={handleUpdate} onShowNotification={handleShowNotification} />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <NavigationBar />
      <main className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 mb-20 md:mb-0">
        <div className="mb-8 md:mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">Settings</h1>
          <p className="text-base md:text-lg text-muted-foreground">
            Manage your account settings and preferences
          </p>
        </div>

        <div className="hidden md:block mb-8">
          <div className="border-b border-border">
            <nav className="flex gap-8">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 pb-4 border-b-2 transition-colors ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground'
                  }`}
                >
                  <Icon name={tab?.icon} size={20} />
                  <span className="font-medium">{tab?.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </div>

        <div className="md:hidden mb-6">
          <div className="bg-card rounded-lg border border-border overflow-hidden">
            {tabs?.map((tab, index) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`w-full flex items-center justify-between p-4 transition-colors ${
                  index !== tabs?.length - 1 ? 'border-b border-border' : ''
                } ${
                  activeTab === tab?.id
                    ? 'bg-primary/5 text-primary' :'text-foreground hover:bg-muted'
                }`}
              >
                <div className="flex items-center gap-3">
                  <Icon name={tab?.icon} size={20} />
                  <span className="font-medium">{tab?.label}</span>
                </div>
                {activeTab === tab?.id && (
                  <Icon name="Check" size={20} color="var(--color-primary)" />
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="animate-fadeIn">
          {renderTabContent()}
        </div>
      </main>
    </div>
  );
};

const UserProfileSettings = () => {
  return (
    <NotificationProvider>
      <UserProfileSettingsContent />
    </NotificationProvider>
  );
};

export default UserProfileSettings;